var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"index-page"},[_c('div',{staticClass:"vditor",staticStyle:{"height":"650px","width":"auto"},attrs:{"id":"vditor"}})])}
var staticRenderFns = []

export { render, staticRenderFns }